export default "__VITE_PUBLIC_ASSET__07a6376d__"